import {
  IFluxoAdminEtapaForm,
  IFluxoAdminEtapaRegistro,
} from '../../modules/types/FluxoAdmin';
import httpClient from '../httpClient';

const API_BASE = '/api/fluxoadmetapas';

export const getFluxoAdminEtapaById = async (
  id: string | number,
): Promise<IFluxoAdminEtapaRegistro> => {
  const response = await httpClient.get(`${API_BASE}/${id}`);
  return response.data;
};

export const getFluxoAdminEtapasByModeloId = async (
  modeloId: number,
): Promise<IFluxoAdminEtapaRegistro[]> => {
  const response = await httpClient.get(`${API_BASE}/modelo/${modeloId}`);

  return Array.isArray(response.data?.registros) ? response.data.registros : [];
};

export const handleCreateFluxoAdminEtapa = async (
  form: IFluxoAdminEtapaForm,
): Promise<any> => {
  const response = await httpClient.post(API_BASE, form);
  return response.data;
};

export const handleUpdateFluxoAdminEtapa = async (
  form: IFluxoAdminEtapaForm,
): Promise<any> => {
  const response = await httpClient.patch(`${API_BASE}/${form.id}`, form);
  return response.data;
};

export const handleDeleteFluxoAdminEtapa = async (
  id: string | number,
): Promise<any> => {
  const response = await httpClient.delete(`${API_BASE}/${id}`);
  return response.data;
};
